import styled from "styled-components";
import {PointDefinition} from "../../../../services/onboarding-tour/geometry.helper";

export function radialGradientModel(radius: number, positionCoordinates: PointDefinition, opacity: number = 0) {
    return `radial-gradient(circle at ${positionCoordinates.x}px ${positionCoordinates.y}px, rgba(0, 0, 0, ${opacity}) ${radius}px, rgba(0, 0, 0, 1) ${radius}px)`;
}

export interface IMaskCutoutProps {
    positionCoordinates: {
        x: number;
        y: number;
    };
    radius: number;
    opacity: number;
    zIndex: number;
}

export const MaskCutoutBox = styled.div<IMaskCutoutProps>`
    z-index: ${({zIndex}) => zIndex};
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    right: 0;
    mask-image: ${(props) => radialGradientModel(props.radius, props.positionCoordinates, props.opacity)};
`;
